import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountSecurityRoutingModule } from './account-security-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AccountSecurityRoutingModule
  ]
})
export class AccountSecurityModule { }
